import { render, staticRenderFns } from "./homeSchool.vue?vue&type=template&id=2ff0acb8&scoped=true"
import script from "./homeSchool.vue?vue&type=script&lang=js"
export * from "./homeSchool.vue?vue&type=script&lang=js"
import style0 from "./homeSchool.vue?vue&type=style&index=0&id=2ff0acb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0acb8",
  null
  
)

export default component.exports